import { render, staticRenderFns } from "./Situation.vue?vue&type=template&id=587ceb10&scoped=true&"
import script from "./Situation.vue?vue&type=script&lang=js&"
export * from "./Situation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587ceb10",
  null
  
)

export default component.exports